<template>
  <span>
    <b-form inline v-if="plps.length">
      <header id="_bv_dropdown-group-1_group_dd_header" class="dropdown-header">
        PLPs
      </header>
      <b-form-select
        size="sm"
        :options="options_plps"
        v-model="selected_plp_id"
      >
      </b-form-select>
      <b-button
        size="sm"
        variant="success"
        @click="getPlp()"
        :disabled="loading_b"
      >
        {{ !loading_b ? "Baixar" : "Carregando..." }}
      </b-button>
    </b-form>
    <br />
  </span>
</template>

<script>
import swal from "sweetalert2";
import axios from "axios";
export default {
  name: "PLPsDownload",
  data() {
    return {
      plps: [],
      options_plps: [],
      selected_plp_id: null,
      loading_b: false,
    };
  },
  methods: {
    getPlp() {
      this.loading_b = true;
      axios
        .get(`/api/documents/get_plp/${this.selected_plp_id}`)
        .then((response) => {
          this.downloadFile(
            response.data.url,
            `plp_${response.data.sigep_plp_id}.pdf`
          );
          this.loading_b = false;
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t(error.response.data),
            type: "error",
          });
          this.loading_b = false;
        });
    },
    getLatestPlp() {
      axios
        .get(`/api/documents/get_latest_plp`)
        .then((response) => {
          this.plps = response.data;

          for (var i in this.plps) {
            this.options_plps.push({
              value: this.plps[i].id,
              text: this.plps[i].sigep_plp_id,
            });
          }

          this.selected_plp_id = this.plps.length ? this.plps[0].id : this.plps;
        })
        .catch((error) => {
        });
    },
    downloadFile(url, fileName) {
      // Create an invisible A element
      const a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);

      // Set the HREF to a Blob representation of the data to be downloaded
      a.href = url;

      // Use download attribute to set set desired file name
      a.setAttribute("download", fileName);
      a.setAttribute("target", "_blank");

      // Trigger the download by simulating click
      a.click();

      // Cleanup
      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
    },
  },
  beforeMount() {
    this.getLatestPlp();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/ActionMenuDropdown/PLPsDownload.vue